(() => {
  const rgbToLuminance = (rgbString) => {
    const parts = (rgbString.match(/[\d.]+/g) || [])
      .slice(0, 3)
      .map((value) => parseFloat(value))
      .filter((value) => !Number.isNaN(value));

    if (parts.length < 3) return 1;

    const channel = (value) => {
      const normalized = value / 255;
      return normalized <= 0.03928
        ? normalized / 12.92
        : Math.pow((normalized + 0.055) / 1.055, 2.4);
    };

    const [r, g, b] = parts;
    return 0.2126 * channel(r) + 0.7152 * channel(g) + 0.0722 * channel(b);
  };

  const applySwatchContrast = (root = document) => {
    root
      .querySelectorAll('.product-info--pdp .product-form__input--swatch .swatch-input__label')
      .forEach((label) => {
        const swatch = label.querySelector('.swatch');
        if (!swatch) return;

        const backgroundColor = window.getComputedStyle(swatch).getPropertyValue('background-color');
        const luminance = rgbToLuminance(backgroundColor);
        const textColor = luminance > 0.55 ? '#0f172a' : '#f8fafc';
        label.style.setProperty('--swatch-text-color', textColor);
      });
  };

  const queueApply = (event) => {
    window.requestAnimationFrame(() => {
      const root =
        event?.target instanceof Element
          ? event.target.closest('[id^="shopify-section-"]') || document
          : document;

      applySwatchContrast(root);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => applySwatchContrast(), { once: true });
  } else {
    applySwatchContrast();
  }

  document.addEventListener('shopify:section:load', queueApply);
  document.addEventListener('variant:change', queueApply);
  document.addEventListener('variant:changed', queueApply);
})();
